// eslint-disable-next-line no-restricted-imports
import { AccountHistoryItemLogEntryTypeEnum } from '@eih-netbroker/api-order';

export const OrderHistoryItemLogEntryType = AccountHistoryItemLogEntryTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderHistoryItemLogEntryType =
  (typeof OrderHistoryItemLogEntryType)[keyof typeof OrderHistoryItemLogEntryType];
